
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#000","version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 247.065 247.065","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M160.551 36.935a7.5 7.5 0 00-9.451-4.815l-31.376 10.196a7.499 7.499 0 00-4.815 9.45l1.568 4.828-79.811 58.625-31.483 10.229a7.502 7.502 0 00-4.815 9.451l19.129 58.862a7.504 7.504 0 007.131 5.184 7.5 7.5 0 002.32-.369l31.478-10.229 16.173.085c3.248 15.336 16.888 26.88 33.176 26.88 16.164 0 29.714-11.371 33.095-26.531l16.587.087 1.568 4.829a7.495 7.495 0 007.133 5.182c.78 0 1.563-.122 2.317-.367l31.377-10.195a7.5 7.5 0 004.816-9.45L160.551 36.935zM31.444 181.992l-14.492-44.597 18.364-5.967 14.49 44.597-18.362 5.967zm78.33 18.32c-7.912 0-14.694-4.887-17.513-11.797l34.958.184c-2.863 6.815-9.602 11.613-17.445 11.613zm-45.06-26.943l-7.888-24.277-7.888-24.277 72.419-53.194 22.209 68.349 11.006 33.873-89.858-.474zm108.258 8.56l-.921-2.833-.004-.017-19.815-60.983-20.74-63.833 17.111-5.561 41.48 127.665-17.111 5.562zM185.807 73.393a7.5 7.5 0 0010.088-3.277l13.461-26.41a7.5 7.5 0 10-13.363-6.812l-13.461 26.41a7.5 7.5 0 003.275 10.089zM242.176 144.712l-26.414-13.455a7.5 7.5 0 00-6.809 13.366l26.414 13.455a7.502 7.502 0 006.809-13.366zM204.242 101.204a7.504 7.504 0 007.131 5.184 7.5 7.5 0 002.32-.369l28.188-9.16a7.5 7.5 0 00-4.637-14.266l-28.188 9.16a7.501 7.501 0 00-4.814 9.451z"}})])
          )
        }
      }
    